import { useState } from "react";
import { Icon } from "../lib/Icon";
import {
  DONATION_KEY_HANDLE,
  DONATION_KEY_NAME,
  DONATION_URL,
  HAS_DONATIONS,
  SUGGESTED_AMOUNTS,
} from "../config";
import { useToast } from "../lib/toast";

export function DonateScreen() {
  return (
    <div className="page" style={{ maxWidth: 720, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: 32 }}>
        <div style={{ fontSize: 64, marginBottom: 12 }}>☕</div>
        <h1 style={{ fontFamily: "var(--font-display)", fontSize: 36, fontWeight: 800, margin: 0, letterSpacing: "-0.02em" }}>
          Apoya PaniniNilabs
        </h1>
        <p style={{ color: "var(--fg-muted)", fontSize: 17, margin: "12px 0 0", maxWidth: 540, marginInline: "auto" }}>
          Construimos PaniniNilabs como un proyecto de Nilabs porque amamos los álbumes del Mundial — y queremos que todos lo disfruten gratis.
        </p>
      </div>

      <div className="card" style={{ background: "linear-gradient(135deg, var(--primary-soft), var(--bg-card))", marginBottom: 24 }}>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 22, margin: "0 0 12px" }}>
          ¿Por qué donar?
        </h2>
        <ul style={{ paddingLeft: 18, color: "var(--fg)", lineHeight: 1.8, margin: 0 }}>
          <li><b>Mantener el servidor:</b> cada match, mensaje y publicación tiene un costo</li>
          <li><b>Mantenerlo gratis para siempre:</b> sin anuncios invasivos, sin paywalls</li>
          <li><b>Construir features que pidan:</b> notificaciones, mapa, app móvil…</li>
          <li><b>Apoyar el proyecto Nilabs:</b> equipo que también construye herramientas de IA para empresas en Colombia</li>
        </ul>
      </div>

      <div className="card" style={{ marginBottom: 24 }}>
        <h2 style={{ fontFamily: "var(--font-display)", fontSize: 22, margin: "0 0 12px" }}>
          Cómo funciona
        </h2>
        <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "10px 16px", alignItems: "start" }}>
          <Step n={1} />
          <div>Da click en el botón de abajo. Te lleva a Mercado Pago.</div>
          <Step n={2} />
          <div>Eliges el monto que quieras (mínimo $1.000 COP, no hay máximo).</div>
          <Step n={3} />
          <div>Pagas con tarjeta, PSE, Daviplata, Nequi o Mercado Pago.</div>
          <Step n={4} />
          <div>Listo — nos llega y financia el siguiente mes de servidor 🙏</div>
        </div>
      </div>

      {HAS_DONATIONS && <DonateCTA />}

      <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0 12px", color: "var(--fg-muted)" }}>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
        <span style={{ fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
          O también
        </span>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
      </div>

      <TransferKeyCard />

      {!HAS_DONATIONS && (
        <div style={{ marginTop: 16, padding: 12, background: "var(--bg-subtle)", borderRadius: 8, fontSize: 13, color: "var(--fg-muted)", textAlign: "center" }}>
          <Icon name="settings" size={12} /> Estamos finalizando la integración con Mercado Pago. Por ahora puedes apoyar directo por llave Bre-B.
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: 32, color: "var(--fg-muted)", fontSize: 13 }}>
        <Icon name="heart" size={12} /> Gracias a todos los que ya apoyaron · proyecto de{" "}
        <a href="https://nilabs.co" target="_blank" rel="noopener noreferrer" style={{ color: "var(--primary)", fontWeight: 600 }}>Nilabs</a>
      </div>
    </div>
  );
}

function Step({ n }: { n: number }) {
  return (
    <div style={{ width: 28, height: 28, borderRadius: "50%", background: "var(--primary)", color: "white", display: "grid", placeItems: "center", fontWeight: 700, fontSize: 14 }}>
      {n}
    </div>
  );
}

function DonateCTA() {
  return (
    <div className="card" style={{ textAlign: "center", padding: 32, background: "linear-gradient(135deg, var(--primary), var(--accent-amber))", color: "white", border: 0 }}>
      <h3 style={{ fontFamily: "var(--font-display)", fontSize: 22, margin: "0 0 8px" }}>Cualquier monto ayuda</h3>
      <p style={{ opacity: 0.9, margin: "0 0 16px", fontSize: 14 }}>
        El monto sugerido es lo que cuesta un café. Pero tú eliges.
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap", marginBottom: 20 }}>
        {SUGGESTED_AMOUNTS.map((a) => (
          <span key={a} style={{ background: "rgba(255,255,255,0.2)", padding: "6px 14px", borderRadius: 999, fontWeight: 700, fontSize: 14 }}>
            ${a.toLocaleString("es-CO")}
          </span>
        ))}
      </div>
      <a
        href={DONATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-lg"
        style={{
          background: "white",
          color: "var(--pitch-700)",
          fontWeight: 700,
          textDecoration: "none",
          padding: "14px 32px",
          borderRadius: 12,
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        ☕ Apoyar con Mercado Pago <Icon name="arrow" size={16} />
      </a>
      <div style={{ marginTop: 14, fontSize: 12, opacity: 0.85 }}>
        Tarjeta · PSE · Daviplata · Nequi · saldo MP. Te cobran solo lo que dones.
      </div>
    </div>
  );
}

function TransferKeyCard() {
  const toast = useToast();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(DONATION_KEY_HANDLE);
      setCopied(true);
      toast(`Llave copiada: ${DONATION_KEY_HANDLE}`);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast("No se pudo copiar — escríbela manualmente");
    }
  };

  return (
    <div className="card" style={{ borderTop: "3px solid var(--primary)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 10, background: "var(--primary)", color: "white", display: "grid", placeItems: "center", fontWeight: 800, fontFamily: "var(--font-display)", fontSize: 18 }}>
          🔑
        </div>
        <div>
          <h3 style={{ fontFamily: "var(--font-display)", fontSize: 18, margin: 0 }}>Transferencia por llave Bre-B</h3>
          <div className="tiny muted">100% del monto llega · funciona desde Nequi, Daviplata, Bancolombia, Davivienda y todas las billeteras</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, alignItems: "stretch", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 200px", background: "var(--bg-subtle)", padding: "12px 16px", borderRadius: 10, fontFamily: "var(--font-mono, monospace)", fontWeight: 700, fontSize: 20, letterSpacing: 0.5, display: "grid", placeItems: "center" }}>
          {DONATION_KEY_HANDLE}
        </div>
        <button className="btn btn-primary" onClick={copy} style={{ minWidth: 120, justifyContent: "center" }}>
          {copied ? <><Icon name="check" size={14} /> Copiado</> : <>📋 Copiar llave</>}
        </button>
      </div>

      <div style={{ fontSize: 13, color: "var(--fg-muted)", marginTop: 12, lineHeight: 1.6 }}>
        <b>Cómo enviar:</b> Abre tu app bancaria → "Enviar / Transferir" → elige <b>Llave Bre-B</b> → pega <b>{DONATION_KEY_HANDLE}</b> → escribe el monto → confirma.<br />
        Aparecerá <b>{DONATION_KEY_NAME}</b> como destinatario.
      </div>

      <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>
        {SUGGESTED_AMOUNTS.map((a) => (
          <span key={a} style={{ padding: "4px 10px", borderRadius: 999, background: "var(--bg-subtle)", fontSize: 12, fontWeight: 600 }}>
            ${a.toLocaleString("es-CO")}
          </span>
        ))}
      </div>
    </div>
  );
}
